<template>
  <GridPart
      maxWidth="calc(100% - 80px)"
      :title="title"
      :hasSearch="true"
      :hasFilter="false"
      :hasExtra="true"
      :standardClass="() => {}"
      :extraClass="() => {}"
      :colspan="6"
      empty="Nenašli sa žiadne výkazy."
      itemsKey="ticketItemReports"
      filterKey="TicketItemReport"
      defaultOrder="ticiterep.workedAt"
      defaultBy="DESC"
      :defaultLimit="25"
      :fetchData="fetchData"
  >
    <template
        v-slot:action="{
          init
        }"
    >
      <template
          v-if="[TicketItem.Ticket?.Seller?.id, TicketItem.Ticket?.Manager?.id].includes($store.state.auth.User.id)"
      >
        <template
            v-if="TicketItem.ticketItemReportCreatable"
        >
          <CreateTicketItemTicketItemReportAuth
              :ticketItemId="TicketItem.id"
              @onCreateTicketItem="(response) => {
                init()

                $emit('refresh', response)
              }"
          />

          &nbsp;
        </template>
      </template>
    </template>

    <template
        v-slot:search="{
          params,
          errors,
          setSearch
        }"
    >
      <v-text-field
          v-model="params.query"
          :error-messages="errors.query"
          :outlined="true"
          :dense="true"
          hide-details="auto"
          label="Vyhľadávanie"
          :clearable="true"
          @change="setSearch"
      />
    </template>

    <template
        v-slot:list-head="{
          order,
          by,
          orderList,
          byList,
          setOrderBy
        }"
    >
      <th
          class="fixed"
      >
        <OrderList
            orderKey="ticiterep.workedAt"
            :order="order"
            :by="by"
            :orderList="orderList"
            :byList="byList"
            @setOrderBy="setOrderBy"
        />
      </th>

      <th>
        Užívateľ
      </th>

      <th>
        Odpracovaný čas
      </th>

      <template
          v-if="$store.getters['auth/isLogged'] && $store.getters['auth/hasRole']('ROLE_SELLER')"
      >
        <th>
          Plat
        </th>

        <th>
          Odpracovaná suma
        </th>
      </template>

      <th
          class="text-right fixed"
      />
    </template>

    <template
        v-slot:list-body-standard="{
          Item,
          init
        }"
    >
      <td
          class="fixed"
      >
        {{ Item.workedAt|moment('DD.MM.YYYY') }}
      </td>

      <td>
        <TruncateHelper
            :title="Item.User.name"
            maxWidth="300px"
        >
          {{ Item.User.name }}
        </TruncateHelper>
      </td>

      <td>
        {{ Item.timeSpend|number }} h
      </td>

      <template
          v-if="$store.getters['auth/isLogged'] && $store.getters['auth/hasRole']('ROLE_SELLER')"
      >
        <td>
          {{ Item.priceHour|currency('€ / h') }}
        </td>

        <td>
          {{ Item.priceSpend|currency('€') }}
        </td>
      </template>

      <td
          class="text-right fixed"
      >
        <template
            v-if="Item.User.id === $store.state.auth.User.id"
        >
          <template
              v-if="Item.updatable"
          >
            <UpdateTicketItemReportAuth
                :id="Item.id"
                @onUpdate="(response) => {
                  init()

                  $emit('refresh', response)
                }"
            />
          </template>

          <template
              v-if="Item.deletable"
          >
            &nbsp;

            <DeleteTicketItemReportAuth
                :id="Item.id"
                @onDelete="(response) => {
                  init()

                  $emit('refresh', response)
                }"
            />
          </template>
        </template>
      </td>
    </template>

    <template
        v-slot:list-body-extra="{
          Item
        }"
    >
      <td
          :colspan="6"
      >
        <IsEmptyHelper
            :value="Item.note"
            if-no="i"
            if-yes="i"
            empty="bez poznámky"
        >
          {{ Item.note }}
        </IsEmptyHelper>

        <template
            v-if="Item.files.length > 0"
        >
          <template
              v-for="(_File) in Item.files"
          >
            <br
                :key="_File.id + 'br'"
            />

            <a
                :key="_File.id + 'a'"
                :href="$global.axiosUrl() + 'files/'  + _File.token + '/generate/original'"
                target="_blank"
            >
              {{ _File.name }}
            </a>
          </template>
        </template>
      </td>
    </template>
  </GridPart>
</template>

<script>
  import TicketItemReports from '@/services/ticket-item-reports'

  import CreateTicketItemTicketItemReportAuth from '@/components/TicketItemReportsAuth/CreateTicketItem'
  import UpdateTicketItemReportAuth from '@/components/TicketItemReportsAuth/Update'
  import DeleteTicketItemReportAuth from '@/components/TicketItemReportsAuth/Delete'

  import GridPart from '@/components/_Part/Grid'

  import OrderList from '@/components/_Part/_Grid/_List/Order'

  import TruncateHelper from '@/components/_Part/_Helper/Truncate'
  import IsEmptyHelper from '@/components/_Part/_Helper/IsEmpty'

  export default {
    name: 'TicketItemReports',
    props: [
      'TicketItem'
    ],
    emits: [
      'refresh'
    ],
    components: {
      CreateTicketItemTicketItemReportAuth,
      UpdateTicketItemReportAuth,
      DeleteTicketItemReportAuth,
      GridPart,
      OrderList,
      TruncateHelper,
      IsEmptyHelper
    },
    data() {
      return {
        title: 'Výkazy'
      }
    },
    methods: {
      fetchData(params) {
        return TicketItemReports
          .indexTicketItem({
            ticketItemId: this.TicketItem.id,
            params: params
          })
      }
    }
  }
</script>
